import { operationToHar as f } from "@scalar/oas-utils/helpers/operation-to-har";
import { getSnippet as l } from "@scalar/api-client/views/Components/CodeSnippet";
const K = ({
  clientId: r,
  operation: t,
  method: o,
  path: n,
  example: p,
  contentType: i,
  server: a,
  securitySchemes: s
}) => {
  const c = f({
    operation: t,
    contentType: i,
    method: o,
    path: n,
    server: a,
    securitySchemes: s,
    example: p
  }), [g, m] = r.split("/"), [e, d] = l(g, m, c);
  return e ? e.message ?? "Error generating code snippet" : d;
};
export {
  K as generateCodeSnippet
};
